"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attr = exports.attribute = void 0;
const index_js_1 = require("./any/index.js");
const index_js_2 = require("./anyOf/index.js");
const index_js_3 = require("./binary/index.js");
const index_js_4 = require("./boolean/index.js");
const index_js_5 = require("./list/index.js");
const index_js_6 = require("./map/index.js");
const index_js_7 = require("./null/index.js");
const index_js_8 = require("./number/index.js");
const index_js_9 = require("./record/index.js");
const index_js_10 = require("./set/index.js");
const index_js_11 = require("./string/index.js");
__exportStar(require("./any/index.js"), exports);
__exportStar(require("./primitive/index.js"), exports);
__exportStar(require("./null/index.js"), exports);
__exportStar(require("./boolean/index.js"), exports);
__exportStar(require("./number/index.js"), exports);
__exportStar(require("./string/index.js"), exports);
__exportStar(require("./binary/index.js"), exports);
__exportStar(require("./set/index.js"), exports);
__exportStar(require("./list/index.js"), exports);
__exportStar(require("./map/index.js"), exports);
__exportStar(require("./record/index.js"), exports);
__exportStar(require("./anyOf/index.js"), exports);
__exportStar(require("./constants/index.js"), exports);
__exportStar(require("./types/index.js"), exports);
exports.attribute = {
    any: index_js_1.any,
    nul: index_js_7.nul,
    boolean: index_js_4.boolean,
    number: index_js_8.number,
    string: index_js_11.string,
    binary: index_js_3.binary,
    set: index_js_10.set,
    list: index_js_5.list,
    map: index_js_6.map,
    record: index_js_9.record,
    anyOf: index_js_2.anyOf
};
exports.attr = exports.attribute;
